import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M92.3 157.9H12.1C6.5 157.9 2 153 2 147V12.9C2 6.9 6.5 2 12.1 2h175.8c5.6 0 10.1 4.9 10.1 10.9V147c0 6-4.5 10.9-10.1 10.9h-80.8v24h88.2c1.4 0 2.6 1.3 2.6 2.8v10.5c0 1.5-1.2 2.8-2.6 2.8H4.7c-1.4 0-2.6-1.3-2.6-2.8v-10.5c0-1.5 1.2-2.8 2.6-2.8h87.6v-24zM17 141.8h166.1V18.2H17v123.6zM161.4 128H37.3c-1.4 0-2.6-1.3-2.6-2.8V33c0-1.5 1.2-2.8 2.6-2.8h124.1c1.4 0 2.6 1.3 2.6 2.8v92.2c0 1.6-1.2 2.8-2.6 2.8z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}